import { render } from "./graphic-editor.vue?vue&type=template&id=1c4d9932&scoped=true"
import script from "./graphic-editor.vue?vue&type=script&lang=js"
export * from "./graphic-editor.vue?vue&type=script&lang=js"

import "./graphic-editor.vue?vue&type=style&index=0&id=1c4d9932&lang=scss&scoped=true"

import exportComponent from "/usr/local/apps/meng/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4d9932"]])

export default __exports__